import { render, staticRenderFns } from "./CancelBtn.vue?vue&type=template&id=354c02be&scoped=true&lang=pug&"
import script from "./CancelBtn.vue?vue&type=script&lang=js&"
export * from "./CancelBtn.vue?vue&type=script&lang=js&"
import style0 from "./CancelBtn.vue?vue&type=style&index=0&id=354c02be&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c02be",
  null
  
)

export default component.exports